[
  {
    "code": "UM-81",
    "name": "Baker Island"
  },
  {
    "code": "UM-84",
    "name": "Howland Island"
  },
  {
    "code": "UM-86",
    "name": "Jarvis Island"
  },
  {
    "code": "UM-67",
    "name": "Johnston Atoll"
  },
  {
    "code": "UM-89",
    "name": "Kingman Reef"
  },
  {
    "code": "UM-71",
    "name": "Midway Islands"
  },
  {
    "code": "UM-76",
    "name": "Navassa Island"
  },
  {
    "code": "UM-95",
    "name": "Palmyra Atoll"
  },
  {
    "code": "UM-79",
    "name": "Wake Island"
  }
]